import { createSlice } from "@reduxjs/toolkit";
import { createContact } from "../../../thunks/authThunk";
import { message } from "antd";

const initialState = {
  isLoading: false,
  contactStatus: null, // "loading" | "success" | "failed"
  error: null,
};

export const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createContact.pending, (state) => {
        state.isLoading = true;
        state.contactStatus = "loading";
        state.error = null;
      })
      .addCase(createContact.fulfilled, (state, action) => {
        state.isLoading = false;
        state.contactStatus = "success";
      })
      .addCase(createContact.rejected, (state, action) => {
        state.isLoading = false;
        state.contactStatus = "failed";
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default contactSlice.reducer;
